import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react'
import { AiOutlineColumnHeight } from 'react-icons/ai';
import Bid from '../../components/Quote/Bid';
import Ask from '../../components/Quote/Ask';
import { ThemeContext } from '../../../context/ThemeContext';
import PercentageChange from '../../../components/global/BidAsk/PercentageChange';
import SpreadValue from '../../../components/global/BidAsk/SpreadValue';
import Low from '../../../components/global/BidAsk/Low';
import High from '../../../components/global/BidAsk/High';
import Time from '../../../components/global/BidAsk/Time';

export default function AdvanceDetailedView({ symbol, handleQuoteClick }) {
    const { darkMode } = useContext(ThemeContext)

    return (
        <>
            <Box sx={{ p: 1, display: "flex", justifyContent: "space-between" }} onClick={() => handleQuoteClick(symbol)}>
                <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)' }}>
                    <Typography fontSize={12} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><PercentageChange symbolId={symbol?.id} /></Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                    <Box sx={{ display: 'flex', alignItems: "center" }}>
                        <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><Time symbolId={symbol?.id} /> </Typography>
                        <AiOutlineColumnHeight fontSize={13} style={{ margin: "0 0 0 3px", color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} />
                        <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontWeight: 600 }}><SpreadValue symbolId={symbol?.id} /></Typography>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                    <Box>
                        <Bid symbolId={symbol?.id} />
                        <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>L:<Low symbolId={symbol?.id} /></small></Typography>
                    </Box>
                    <Box sx={{ marginLeft: 2 }}>
                        <Ask symbolId={symbol?.id} />
                        <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>H: <High symbolId={symbol?.id} /></small></Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );

}
